import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './sanolivar-style.css';

import Header from './components/Header';
import Footer from './components/Footer';
import BannerNosotros from './components/BannerNosotros';
import Chatbot from './components/Chatbot.jsx';
import { root, assets } from './utils/Path';
import Form from './components/Form';

const assetsNosotros = './assets/images/nosotros/';

const clientes = {
    'ANSV': 'clientes-seguridad-vial.webp',
    'Personería de Bogotá': 'clientes-personeria.webp',
    'Agencia Nacional de Tierras': 'clientes-antierras.webp',
    'Instituto Nacional de Salud': 'clientes-ins.webp',
    'MinTIC': 'clientes-mintic.webp',
    'Ministerio de Ambiente': 'clientes-minambiente.webp',
    'Ministerio de Hacienda': 'clientes-minhacienda.webp',
    'Ministerio de Transporte': 'clientes-mintransporte.webp',
    'Ministerio de Educación': 'clientes-mineducacion.webp',
    'Ministerio de Defensa': 'clientes-mindefensa.webp',
    'Secretaría General': 'clientes-alcaldia-mayor-bogota.webp',
    'Cultura Recreación y Deportes': 'clientes-cultura-recreacion-deportes.webp',
    'Secretaría Gobierno Distrital': 'clientes-gobierno-distrital.webp',
    'Secretaría de Hacienda': 'clientes-secretaria-distrital-hacienda.webp',
    'Superintendencia Financiera': 'clientes-superfinanciera.webp',
    'Superintendencia Solidaria': 'clientes-supersolidaria.webp',
    'DIMAR': 'clientes-dimar.webp',
    'FONCEP': 'clientes-foncep.webp',
}


// redirect to clientes section
document.addEventListener('DOMContentLoaded', e => {
    setTimeout(() => {
        let target = window.location.hash;
        if (target != '#clientes') return;
        document.querySelector(target).scrollIntoView({
            behavior: 'smooth'
        });
    }, 1000);
})

createRoot(document.getElementById('nosotros')).render(
    <StrictMode>
        <Header active={"Nosotros"} />
        <BannerNosotros />
        <section className="compressed dark">
            <p className="stretch centered">Nos comprometemos a cumplir los objetivos de nuestros clientes de manera fiel y contundente, garantizando resultados que reflejen nuestro compromiso con la excelencia.</p>
        </section>
        {/* MISION */}
        <section className='compressed spacing-strong big-gap centered d3-7'>
            <div data-aos="fade-left">
                <h2>Misión</h2>
                <p>Construir y comercializar soluciones tecnológicas basadas en el conocimiento, la Innovación y nuestros fabricantes aliados, para facilitar el desarrollo de los procesos digitales de nuestros clientes, con honestidad, creatividad y responsabilidad.</p>
            </div>
            <img loading="lazy" data-aos="fade-right" src={`${assetsNosotros}mision.webp`} alt="Persona apuntando con un arco a una diana" aria-label='Persona apuntando con un arco a una diana' title='Persona apuntando con un arco a una diana' />
        </section>
        {/* VISION */}
        <section className='compressed spacing-strong big-gap centered d7-3'>
            <img loading="lazy" data-aos="fade-left" src={`${assetsNosotros}vision.webp`} alt="Persona interactuando con un mapa." aria-label='Persona interactuando con un mapa.' title='Persona interactuando con un mapa.' />
            <div data-aos="fade-right">
                <h2>Visión</h2>
                <p>Consolidar una empresa exitosa en el mercado Colombiano por sus proyectos innovadores en IoT, <strong>Inteligencia Artificial</strong>, Location Services y soluciones de Hardware y Software empresarial.</p>
            </div>
        </section>
        {/* POR QUE ESCOGERNOS */}
        <section className='compressed spacing-strong big-gap bg-alt'>
            <h2 data-aos="fade-down">¿Por qué escogernos?</h2>
            <p data-aos="fade-up" className='stretch'>Nuestra idoneidad y sólidos valores se integran para asegurar el cumplimiento de los objetivos establecidos. Acompañamos a nuestros clientes en cada etapa del proceso, desde la definición del problema y la evaluación de opciones de solución, hasta el crecimiento y la planificación del presupuesto. Juntos, modelamos soluciones a medida, que posteriormente implementamos con el respaldo de nuestra Oficina de Gestión de Proyectos (PMO), garantizando así el éxito en cada iniciativa.</p>
            <div className="exposer inner" data-aos="fade-left">
                <div className="card-expo flow">
                    <img loading="lazy" src={`${assetsNosotros}personal.webp`} alt="Equipo de trabajo realizando planeación." aria-label="Equipo de trabajo realizando planeación." title="Equipo de trabajo realizando planeación." />
                    <div>
                        <div>
                            <h3>Personal especializado</h3>
                            <p>Contamos con profesionales altamente capacitados y certificados, comprometidos con la excelencia. Nos mantenemos en constante formación para asegurar que nuestros expertos ofrezcan la mejor asesoría posible.</p>
                        </div>
                    </div>
                </div>
                <div className="card-expo flow">
                    <img loading="lazy" src={`${assetsNosotros}desarrollo.webp`} alt='escritorio con portátil y pantalla extendida.' aria-label='escritorio con portátil y pantalla extendida.' title='escritorio con portátil y pantalla extendida.' />
                    <div>
                        <div>
                            <h3>Área propia de desarrollo</h3>
                            <p>Nuestro equipo de desarrollo de software emplea metodologías ágiles, inteligencia artificial (IA) y mejores prácticas, integrando tecnologías avanzadas como IoT y realidad aumentada (AR) para crear proyectos de alto valor.</p>
                        </div>
                    </div>
                </div>
                <div className="card-expo flow">
                    <img loading="lazy" src={`${assetsNosotros}transparencia.webp`} alt='Monumento sosteniendo una balanza' aria-label='Monumento sosteniendo una balanza' title='Monumento sosteniendo una balanza' />
                    <div>
                        <div>
                            <h3>Transparencia en el proceso</h3>
                            <p>La ética y la honestidad son pilares fundamentales en cada etapa de nuestro proceso. Nuestro código de ética es una realidad tangible que se aplica rigurosamente en todo nuestro ecosistema. ¡Cumplimos nuestra palabra en cada acción que emprendemos!</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* MEMBRESIAS Y RECONOCIMIENTOS */}
        <section className="'compressed spacing-strong big-gap" id='membresias'>
            <h2 data-aos="fade-down">Membresía y Reconocimientos</h2>
            <p data-aos="fade-up" className="stretch">Contamos con certificaciones y el respaldo de cada fabricante, lo que garantiza nuestra capacidad para diseñar, arquitectar, implementar y gestionar las diversas soluciones disponibles en el mercado.</p>
            <div className="centered inliner">
                <div className="grid5" data-aos="fade-down">
                    <img loading="lazy" src={`${assetsNosotros}aruba-wan-pro.webp`} alt='Acreditación HPE Profesional SD-WAN' aria-label='Acreditación HPE Profesional SD-WAN' title='Acreditación HPE Profesional SD-WAN' />
                    <img loading="lazy" src={`${assetsNosotros}aruba-networking-spec.webp`} alt='Acreditación Especialista en Seguridad de Borde' aria-label='Acreditación Especialista en Seguridad de Borde' title='Acreditación Especialista en Seguridad de Borde' />
                    <img loading="lazy" src={`${assetsNosotros}aruba-central-spec.webp`} alt='Acreditación especialista Aruba Central' aria-label='Acreditación especialista Aruba Central' title='Acreditación especialista Aruba Central' />
                    <img loading="lazy" src={`${assetsNosotros}aruba-switching-pro.webp`} alt='Certificación Profesional en Switching' aria-label='Certificación Profesional en Switching' title='Certificación Profesional en Switching' />
                    <img loading="lazy" src={`${assetsNosotros}aruba-aca-.webp`} alt='Certificación Asociado Campus Access' aria-label='Certificación Asociado Campus Access' title='Certificación Asociado Campus Access' />
                </div>
                <div className="grid4" data-aos="fade-left">
                    <img loading="lazy" src={`${assetsNosotros}aruba-mobility-pro.webp`} alt='Certificación Profesional Aruba ACMP' aria-label='Certificación Profesional Aruba ACMP' title='Certificación Profesional Aruba ACMP' />
                    <img loading="lazy" src={`${assetsNosotros}aruba-edge-pro.webp`} alt='Certificación Profesional Aruba EDGE' aria-label='Certificación Profesional Aruba EDGE' title='Certificación Profesional Aruba EDGE' />
                    <img loading="lazy" src={`${assetsNosotros}aruba-design-pro.webp`} alt='Certificación Profesional Aruba ACDP' aria-label='Certificación Profesional Aruba ACDP' title='Certificación Profesional Aruba ACDP' />
                    <img loading="lazy" src={`${assetsNosotros}aruba-clearpass-pro.webp`} alt='Certificación Profesional Aruba ClearPass' aria-label='Certificación Profesional Aruba ClearPass' title='Certificación Profesional Aruba ClearPass' />
                </div>
                <div className="grid3" data-aos="fade-right">
                    <img loading="lazy" src={`${assetsNosotros}hpe-solution-foundations.webp`} alt='Certificación Solutions Fundations 2024 HPE Sales' aria-label='Certificación Solutions Fundations 2024 HPE Sales' title='Certificación Solutions Fundations 2024 HPE Sales' />
                    <img loading="lazy" src={`${assetsNosotros}hpe-at.webp`} alt='Certificación HPE ATP Hybrid IT Solutions V2' aria-label='Certificación HPE ATP Hybrid IT Solutions V2' title='Certificación HPE ATP Hybrid IT Solutions V2' />
                    <img loading="lazy" src={`${assetsNosotros}hpe-ase.webp`} alt='Certificación HPE ASE Hybrid Solutions Architect V1' aria-label='Certificación HPE ASE Hybrid Solutions Architect V1' title='Certificación HPE ASE Hybrid Solutions Architect V1' />
                </div>
                <div className="grid1" data-aos="fade-left">
                    <img loading="lazy" src={`${assetsNosotros}hpe-sales-aruba.webp`} alt='Certificación Profesional Networking Solutions' aria-label='Certificación Profesional Networking Solutions' title='Certificación Profesional Networking Solutions' />
                </div>
                <div className="grid1" data-aos="fade-right">
                    <img loading="lazy" src={`${assetsNosotros}hpe-certification-pa.webp`} alt='Certificación HPE Distinction Program 2024' aria-label='Certificación HPE Distinction Program 2024' title='Certificación HPE Distinction Program 2024' />
                </div>
                <div className="grid1" data-aos="fade-up">
                    <img loading="lazy" src={`${assetsNosotros}hpe-greenlake.webp`} alt='Certificación HPE GreenLake Workload Solution' aria-label='Certificación HPE GreenLake Workload Solution' title='Certificación HPE GreenLake Workload Solution' />
                </div>
                <div className="grid1" data-aos="fade-up">
                    <img loading="lazy" src={`${assetsNosotros}nvidia-associate.webp`} alt='Certificación Nvidia Associate - AI Infrastructure & Operations' aria-label='Certificación Nvidia Associate - AI Infrastructure & Operations' title='Certificación Nvidia Associate - AI Infrastructure & Operations' />
                </div>
            </div>
        </section>

        <section className="compressed bg-alt" id='clientes'>
            <h2 data-aos="fade-up">Nuestros Clientes</h2>
            <div className="grid4 clientes">
                {
                    Object.keys(clientes).map((cli, index) => (
                        <div data-aos={`fade-${index % 2 == 0 ? 'up' : 'down'}`} id={"card-" + cli.match(/[a-zA-Z]/g).join("")} shake="true" shake-angle="20" shake-scale="1.2" shake-glow="true" shake-floating="true" key={cli}>
                            <img loading="lazy" shake-depth="3" src={`./assets/images/clientes/${clientes[cli]}`} alt={`Logo de ${cli}`} />
                            <span shake-depth="1">{cli}</span>
                        </div>
                    ))
                }
            </div>
        </section>

        <Form
            title={'Contáctanos para solicitar Asesoría'}
            content={'Para más información sobre nuestros productos y servicios por favor completa el formulario.'}
            img={{ src: `${assetsNosotros}contacto.webp`, alt: 'Persona programando en la consola de comandos' }}
            form={[
                {
                    label: 'Nombre contacto',
                    type: 'text',
                    id: 'nombre',
                    placeholder: 'Ingrese su nombre aquí'
                },
                {
                    label: 'Correo electrónico',
                    type: 'email',
                    id: 'email',
                    placeholder: 'Ingrese su correo aquí'
                },
                {
                    label: 'Mensaje',
                    type: 'textarea',
                    id: 'mensaje',
                    placeholder: 'Déjanos un mensaje aquí'
                },
                {
                    label: 'Enviar Mensaje',
                    type: 'submit',
                    id: 'submit',
                }
            ]}
            redirect={`${root}nosotros.html`}
        />
        <Footer />
        <Chatbot />
    </StrictMode>
)